import { z } from 'zod';

const segmentSchemaCommon = z.object({
  uuid: z.string(),
  name: z.string(),
});

export const segmentsSchema = z
  .object({
    inAllSegments: z.array(segmentSchemaCommon).optional(),
    inAnySegments: z.array(segmentSchemaCommon).optional(),
    notInAnySegments: z.array(segmentSchemaCommon).optional(),
  })
  .optional();
